module.exports = __webpack_public_path__ + "static/media/aboutUs1.35b8c768.png";